module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: {
      top: _vm.type === "top", bottom: _vm.type === "bottom", "is-scrolling": _vm.isScrolling, "show--info": _vm.showInfo
    },
    attrs: {
      "data-visible": _vm.visible
    }
  }, [_c('button', {
    staticClass: "wrap-link",
    class: {
      'is-active': _vm.$route.name === 'Current'
    },
    on: {
      "click": function($event) {
        _vm.navto("current")
      }
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Current")])]), _c('button', {
    staticClass: "wrap-link",
    class: {
      'is-active': _vm.$route.name === 'Projects'
    },
    on: {
      "click": function($event) {
        _vm.navto("projects")
      }
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Projects")])]), _c('button', {
    staticClass: "wrap-link",
    class: {
      'is-active': _vm.$route.name === 'Info'
    },
    on: {
      "click": function($event) {
        _vm.navto("info")
      }
    }
  }, [_c('div', {
    staticClass: "heading desktop"
  }, [_vm._v("Information")]), _c('div', {
    staticClass: "heading mobile"
  }, [_vm._v("Info")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ee2a7b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 151
// module chunks = 1